// Common helper utilities for tools

/**
 * Build prospect payload. Accepts dynamic values and ensures field names required by API.
 * @param {Object} values - { company_id, company_name, user_name, email, phone_number }
 * @returns {Object}
 */
export const buildProspectPayload = (values = {}) => {
  return {
    company_id: values.company_id ?? 0,
    company_name: values.company_name ?? values.companyName ?? '',
    user_name: values.user_name ?? values.userName ?? '',
    email: values.email ?? '',
    phone_number: values.phone_number ?? values.phoneNumber ?? '',
    ...(values.city !== undefined && { city: values.city }),
    ...(values.work_field !== undefined && { work_field: values.work_field })
  };
};

// Helper to merge dynamic header/title values for the form
export const getFormHeader = (overrides = {}) => {
  return {
    title: overrides.title ?? 'Access your tools workspace',
    subtitle: overrides.subtitle ?? 'Enter your details to access the tools panel',
    highlighted: overrides.highlighted ?? ''
  };
};
